// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header ion-toolbar {
  padding-bottom: 0.75rem;
  --background: white;
}
ion-header ion-toolbar ion-icon {
  font-size: 2rem;
}
ion-header ion-toolbar.toolbar-container {
  overflow: unset;
  contain: unset;
}
ion-header.bg-primary ion-toolbar {
  --background: var(--ion-color-primary);
  --color: var(--ion-color-primary-contrast);
}
ion-header.bg-primary ion-icon {
  --ion-color-base: var(--ion-color-primary-contrast) !important;
}
ion-header.bg-primary * {
  --color: var(--ion-color-primary-contrast);
  color: var(--ion-color-primary-contrast);
}
ion-header h1 {
  font-size: 1.875rem;
  padding: 0 0.5rem;
}
ion-header ion-buttons button {
  background: transparent;
}
ion-header ion-avatar {
  border: 4px solid #FFFFFF;
  height: 3.25rem;
  width: 3.25rem;
  filter: drop-shadow(0px 2px 15px rgba(101, 101, 101, 0.15));
  margin-left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.component.scss"],"names":[],"mappings":"AACE;EACE,uBAAA;EACA,mBAAA;AAAJ;AACI;EACE,eAAA;AACN;AAEI;EAEE,eAAA;EACA,cAAA;AADN;AAMI;EACE,sCAAA;EACA,0CAAA;AAJN;AAOI;EACE,8DAAA;AALN;AAQI;EACE,0CAAA;EACA,wCAAA;AANN;AAUE;EACE,mBAAA;EACA,iBAAA;AARJ;AAYI;EACE,uBAAA;AAVN;AAcE;EACE,yBAAA;EACA,eAAA;EACA,cAAA;EAEA,2DAAA;EACA,mBAAA;AAbJ","sourcesContent":["ion-header {\n  ion-toolbar {\n    padding-bottom: .75rem;\n    --background: white;\n    ion-icon {\n      font-size: 2rem;\n    }\n\n    &.toolbar-container {\n\n      overflow: unset;\n      contain: unset;\n    }\n  }\n\n  &.bg-primary {\n    ion-toolbar {\n      --background: var(--ion-color-primary);\n      --color: var(--ion-color-primary-contrast);\n    }\n\n    ion-icon {\n      --ion-color-base: var(--ion-color-primary-contrast) !important;\n    }\n\n    * {\n      --color: var(--ion-color-primary-contrast);\n      color: var(--ion-color-primary-contrast);\n    }\n  }\n\n  h1 {\n    font-size: 1.875rem;\n    padding: 0 .5rem;\n  }\n\n  ion-buttons {\n    button {\n      background: transparent;\n    }\n  }\n\n  ion-avatar {\n    border: 4px solid #FFFFFF;\n    height: 3.25rem;\n    width: 3.25rem;\n    // filter: drop-shadow(0px 4px 20px rgba(101, 101, 101, 0.15));\n    filter: drop-shadow(0px 2px 15px rgba(101, 101, 101, 0.15));\n    margin-left: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
